/**
 * Micheals Infrastructure Advisory - API Configuration
 * VERSION: 2026.07.09
 * ROLE: Centralized Routing & Fetch Service
 */

const DEVELOPMENT_API = 'http://localhost:5001';
const PRODUCTION_API = 'https://api.medconsulting.solutions';

export const API_BASE = process.env.NODE_ENV === 'development' ? DEVELOPMENT_API : PRODUCTION_API;

/**
 * Centralized Route Definitions
 * Aligned with Backend Mounting Points
 */
export const ROUTES = {
  // Admin & Provisioning
  ACTIVE_DIRECTIVES: `/api/admin/active-directives`,
  ADMIN_LEADS: `/api/admin/leads`,
  CREATE_SESSION: `/api/provisioning/create-session`,
  GENERATE_BRIEF: `/api/provisioning/generate-brief`,
  CREATE_PAYMENT: `/api/payments/create-consultation-session`,
  
  // Intelligence & Tracking
  TRACK_VISITOR: `/api/intelligence/track-visitor`,
  GET_MARKET_QUOTE: `/api/intelligence/get-market-quote`,
  
  // Proxies & Client State
  CLIENT_ARCHIVE: (sessionId) => `/api/client/archive/${sessionId}`,
  SESSION_STATE: (sessionId) => `/api/client/session-state/${sessionId}`,
  UPLOAD_VAULT: `/api/client/upload-to-vault`,
  PROXY_INTAKE: `/api/proxy/intake`,
  PROXY_TRACK: `/api/proxy/track`,
  
  // Legacy / Administrative Utilities
  FINALIZE_REVIEW: (id) => `/api/admin/finalize-review/${id}`,
  LIST_VAULT: (id) => `/api/admin/list-vault/${id}`,
  UPLOAD_DESIGN: (id) => `/api/admin/upload-design/${id}`,
  VERIFY_BRIEF: (id) => `/api/verify-brief/${id}`,
};

/**
 * Standard API client for general requests.
 * Uses session-based authentication via x-ava-session-id.
 */
export const apiClient = async (url, options = {}) => {
  // Hardened: Ensure consistency with useSalesEngine by using 'session_id'
  const sessionId = localStorage.getItem('session_id');

  // 1. HARDEN: If the URL already starts with http, do not prepend API_BASE
  // This prevents the double-domain issue
  const isFullUrl = url.startsWith('http');
  const cleanUrl = url.startsWith('/') ? url.substring(1) : url;
  const finalUrl = isFullUrl ? url : `${API_BASE}/${cleanUrl}`;

  const headers = {
    'Content-Type': 'application/json',
    'x-ava-session-id': sessionId || '', 
    ...options.headers,
  };

  try {
    const response = await fetch(finalUrl, {
      ...options,
      headers,
      credentials: 'include' 
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `Request failed with status ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("[API_CLIENT_ERROR]:", error.message);
    throw error;
  }
};

export const secureFetch = apiClient;